import Page from '../../classes/Page';
import {$events} from '../../../helpers/events';
import {$dom} from '../../../helpers/dom';
import variables from '../../../variables';
import Choices from 'choices.js';
import ScrollTrigger from 'gsap/ScrollTrigger';
import {isElement, sleep} from '../../../helpers/_utilities';
import gsap from "gsap";
import SmoothScrollbar from 'smooth-scrollbar';
import {$style} from '../../../helpers/style';
import ModalAddressChoice from '../../components/addressChoice';
import showMoreMinHeight from './view/showMoreMinHeight';
import catalogFilterView from './view/filter';
import catalogStickyPagination from './view/stickyPagination';

gsap.registerPlugin(ScrollTrigger);

let filterView = catalogFilterView();

const methods = [
	filterView,
	catalogStickyPagination()
];

const catalogPage = new Page({
	onInit() {

		this.modalAddressChoice = new ModalAddressChoice({
			debug: false,
			name: 'catalogModalAddressChoice',
			rootElementId: 'js-address-choice',
		});

		this.modalAddressChoice.init();

		this.filterView = filterView;

		this.processMethods('init', methods);
	},
	onDestroy() {
		this.processMethods('destroy', methods);
	},
	name: 'catalog',
	rootElementId: 'js-catalog-page',
	resizeDependentMethods: [
		showMoreMinHeight
	]
});

export default catalogPage;
